import React from "react";
import "./styles/ButtonPublierPost.css";

function ButtonPublierPost() {
  return (
    <button type="submit" className="buttonpublierpost">
      <h3>Publier</h3>
    </button>
  );
}
export default ButtonPublierPost;
